/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IMAGE_BASE_URL } from '../config';
import { useGetData } from '../hooks/useGetData';
import { insertEvent, updateEvent } from '../services/appServices';
import './Admin.css';

function AdminFormInsertAgenda({ itemToUpdate, handleBackdrop }) {
  const { data: spectacles } = useGetData({ column: 'spectacles' });
  const [eventDate, setEventDate] = useState(null);
  const [spectacleAsocie, setSpectacleAsocie] = useState(null);
  const [imageDrop, setImageDrop] = useState('');
  // This useEffect take the spectacle atach to the event if its exist and parse de date
  useEffect(() => {
    if (itemToUpdate && itemToUpdate.date) {
      const [year, month, day] = itemToUpdate.date.split('T')[0].split('-');
      const adjustedDay = parseInt(day) + 1; //TODO: Sumo un día manualmente porque el endpoint devuelve una fecha anterior, issue sin resolver. Capaz zonas horarias...

      const adjustedDate = new Date(year, month - 1, adjustedDay); // Sumar un día

      const formattedDate = `${adjustedDate.getFullYear()}-${String(
        adjustedDate.getMonth() + 1
      ).padStart(2, '0')}-${String(adjustedDate.getDate()).padStart(2, '0')}`;

      setEventDate(formattedDate);
    }
    if (itemToUpdate !== null && itemToUpdate.id_spectacle) {
      setImageDrop(itemToUpdate.background);
      const spectacle = spectacles.filter(
        (spectacle) => spectacle.id === itemToUpdate.id_spectacle
      );
      setSpectacleAsocie(spectacle[0]);
    }
  }, [itemToUpdate, spectacles]);
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      accept: {
        'image/*': [],
      },
      onDrop: (acceptedFiles) => {
        setImageDrop(acceptedFiles[0]);
      },
    });
  useEffect(() => {
    handleBackgroundDrop();
  }, [imageDrop]);

  const handleBackgroundDrop = () => {
    if (itemToUpdate && !acceptedFiles[0]) {
      return `url(${IMAGE_BASE_URL}/images/agenda/${itemToUpdate.background})`;
    } else if (acceptedFiles[0]) {
      return `url(${URL.createObjectURL(imageDrop)})`;
    }
  };
  console.log({ itemToUpdate, spectacleAsocie });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    let formValid = true;
    if (acceptedFiles) {
      formData.set('image', acceptedFiles[0]);
    }

    for (const [key, value] of formData.entries()) {
      const field = e.target.elements[key];
      if (
        (!value || value === 'undefined') &&
        key !== 'date' &&
        key !== 'time' &&
        key !== 'id_spectacle' &&
        key !== 'image' &&
        key !== 'event_link' &&
        key !== 'tickets_link'
      ) {
        field?.classList.add('invalid_field');
        formValid = false;
      } else {
        field?.classList.remove('invalid_field');
      }
    }
    if (!itemToUpdate && acceptedFiles.length === 0) {
      e.target.elements.image.classList.add('invalid_field');
      formValid = false;
    }
    if (
      itemToUpdate &&
      !itemToUpdate.background &&
      acceptedFiles.length === 0
    ) {
      e.target.elements.image.classList.add('invalid_field');
      formValid = false;
    }
    if (!formData.get('date')) formData.set('date', null);
    if (!formData.get('time')) formData.set('time', null);
    if (!formData.get('id_spectacle')) formData.set('id_spectacle', null);

    if (formValid) {
      if (!itemToUpdate) {
        try {
          // insert query function
          const response = await insertEvent(formData);
          if (response.error) {
            window.alert(response.error);
            console.log(response);
          } else {
            window.alert('Evento agregado correctamente');
            window.location.reload();
          }
        } catch (error) {
          console.error('Error al agregar el evento:', error);
          window.alert(
            'Error al agregar el evento. Por favor, inténtalo de nuevo más tarde.'
          );
        }
      } else {
        formData.set('eventId', itemToUpdate.id);
        formData.set('oldImage', itemToUpdate.background);
        // update query function
        try {
          const response = await updateEvent({ newData: formData });
          if (response.error) {
            window.alert(response.error);
            console.log(response);
          } else {
            window.alert('Evento Actualizado correctamente');
            window.location.reload();
          }
        } catch (error) {
          console.error('Error al actualizar el evento:', error);
          window.alert(
            'Error al actualizar el evento. Por favor, inténtalo de nuevo más tarde.'
          );
        }
      }
    } else {
      window.alert('Ramplisez tout les champs');
    }
  };

  return (
    <div>
      <h3>
        {itemToUpdate != null ? 'Actualiser évènement' : 'Nouvel évènement'}
      </h3>
      <form className="admin_form gap-2" onSubmit={handleSubmit}>
        <div
          {...getRootProps()}
          className="form_drop_box"
          style={{
            backgroundColor: isDragActive ? '#3e3e3ec7' : 'none',
            backgroundImage: handleBackgroundDrop(),
            outline: acceptedFiles[0] ? 'none' : 'white 2px dashed',
          }}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>{acceptedFiles[0] ? '' : 'Suelta la imagen aqui...'} </p>
          ) : (
            <p>
              {acceptedFiles[0]
                ? ''
                : 'Arrastra aqui la imagen o haz click aqui...'}
            </p>
          )}
        </div>
        <label>
          Title *
          <input
            name="title"
            type="text"
            placeholder="Nom du évènement"
            defaultValue={itemToUpdate !== null ? itemToUpdate?.title : ''}
          />
        </label>
        <label>
          Lieu *
          <input
            name="place"
            type="text"
            placeholder="Nom du lieu"
            defaultValue={itemToUpdate !== null ? itemToUpdate?.place : ''}
          />
        </label>
        {/* <label className="w-full flex flex-col gap-2">
          Description *
          <textarea
            name="description"
            type="text"
            rows="5"
            className="w-full p-1 text-black"
            placeholder="Nom du lieu"
            defaultValue={
              itemToUpdate !== null ? itemToUpdate?.description : ''
            }
          />
        </label> */}
        <label>
          Date (optionnel)
          <input
            name="date"
            type="date"
            placeholder="Date"
            defaultValue={itemToUpdate !== null ? eventDate : ''}
          />
        </label>
        <label>
          Heure (optionnel)
          <input
            name="time"
            type="time"
            placeholder="Heure"
            defaultValue={
              itemToUpdate !== null ? itemToUpdate.time?.slice(0, 5) : ''
            }
          />
        </label>
        <label>
          Adresse *
          <input
            name="adresse"
            type="text"
            placeholder="Adresse"
            defaultValue={itemToUpdate !== null ? itemToUpdate.adresse : ''}
          />
        </label>
        <label>
          Link Google Maps *
          <input
            name="google_link"
            type="text"
            placeholder="Link Google Maps"
            defaultValue={itemToUpdate !== null ? itemToUpdate.google_link : ''}
          />
        </label>
        <label>
          Tickets link (optionnel)
          <input
            name="tickets_link"
            type="text"
            placeholder="Link pour l'achat de tickets"
            defaultValue={
              itemToUpdate !== null ? itemToUpdate.tickets_link : ''
            }
          />
        </label>
        <label>
          Link de l'évènement (optionnel)
          <input
            name="event_link"
            type="text"
            placeholder="Link de l'évènement"
            defaultValue={itemToUpdate !== null ? itemToUpdate.event_link : ''}
          />
        </label>
        <label>
          Spectacle associé <br />
          <select
            name="id_spectacle"
            value={spectacleAsocie ? spectacleAsocie.id : 'null'}
            onChange={(e) => {
              const selectedSpectacle = spectacles.find(
                (spectacle) => spectacle.id === parseInt(e.target.value, 10)
              );
              setSpectacleAsocie(selectedSpectacle || null);
            }}
          >
            <option value="null">Pas d'event associé</option>
            {spectacles && spectacles.length > 0 ? (
              spectacles.map((spectacle) => (
                <option key={spectacle.id} value={spectacle.id}>
                  {spectacle.title}
                </option>
              ))
            ) : (
              <option disabled>Aucun événement disponible</option>
            )}
          </select>
        </label>
        <button type="submit">Confirmer</button>
        <button type="button" onClick={handleBackdrop}>
          Cancelar
        </button>
      </form>
    </div>
  );
}

export default AdminFormInsertAgenda;
